import { ArrowRight } from 'lucide-react';
import Button from '../../../shared/components/button/Button';
import HeroHeader from 'shared/components/header/HeroHeader';
import { SPACES_ROUTE } from 'app/navigation/routes/space-routes';
import { useCallback } from 'react';
import { useNavigationContext } from 'shared/providers/NavigationProvider';
import { useTranslation } from 'react-i18next';

const HeroSection = () => {

    const { t } = useTranslation();
    const { navigateToRoute } = useNavigationContext();

    const handleNavigateToSpacesPage = useCallback(
        () => navigateToRoute(SPACES_ROUTE),
        [navigateToRoute]
    );

    return (
        <section className="min-h-screen relative overflow-hidden bg-black">
            <BackgroundImageWithOverlay />
            {/* Content */}
            <div className="relative z-10">
                <HeroHeader />
                {/* Main Content */}
                <div className="px-6 lg:px-12 mt-12 lg:mt-24 flex flex-col justify-center items-center min-h-[calc(100vh-300px)]">
                    <HeroText />
                    <div className="flex justify-center items-center w-full">
                        <Button
                            onClick={handleNavigateToSpacesPage}
                            className="mt-5 px-4 py-2 bg-lime-700 text-white rounded-lg text-md lg:text-lg font-medium hover:bg-lime-800 transition"
                        >
                            {t('website.hero.button')}
                            <ArrowRight className="inline-block w-5 h-5 ml-2" />
                        </Button>
                    </div>
                </div>
            </div>
        </section>
    );
};

const BackgroundImageWithOverlay = () => (
    <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
            backgroundImage: `url('https://res.cloudinary.com/dorkbt39x/image/upload/v1765328636/meets-N-works/TX-LONE/_MG_9926_TX_LONE_garden_avenue_tower_xwrsky.jpg')`,
        }}
    >
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/70 to-black/50"></div>
    </div>
);

const HeroText = () => {
    const { t } = useTranslation();

    return (
        <div className="max-w-3xl mb-4 lg:mb-0 animate-fade-in  mx-auto flex flex-col justify-center h-full px-4 lg:px-0 text-center ">
            <h2 className="text-4xl lg:text-7xl font-bold text-white leading-tight">
                {t('website.hero.title')}
            </h2>
        </div>
    );
};

export default HeroSection;
